import script from "./ForgetPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForgetPassword.vue?vue&type=script&setup=true&lang=ts"

import "./ForgetPassword.vue?vue&type=style&index=0&id=b7ca0dba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7ca0dba"]])

export default __exports__